"use client"

import { useRouter } from "next/navigation"

import { Button } from "@/components/ui/button"
import {
  PageHeader,
  PageHeaderDescription,
  PageHeaderHeading,
} from "@/components/page-header"
import { Shell } from "@/components/shells/shell"

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  const isDev = process.env.NODE_ENV === "development"
  const router = useRouter()

  return (
    <Shell variant="centered">
      <PageHeader>
        <PageHeaderHeading>Something went wrong!</PageHeaderHeading>
        {isDev ? (
          <>
            <PageHeaderDescription size="sm">
              {error.message}
            </PageHeaderDescription>
            {error.name}. Boundary was which caught is in (namegenerators)/[category]/[...slug]/error.tsx
          </>
        ) : (
          <PageHeaderDescription size="sm">
            An error occurred. Please try again later.
          </PageHeaderDescription>
        )}
      </PageHeader>
      <div className="flex gap-4">
        <Button size="lg" onClick={() => reset()}>
          Try again
        </Button>
        <Button size="lg" variant="outline" onClick={() => router.back()}>
          Go back
        </Button>
      </div>
    </Shell>
  )
}
